<isData class="is-data-wrapper" [noDataIf]="flowItems.length === 0">
  @if (hosts.length) {
    <div class="seq">
      <div class="seq-head">
        <div class="seq-time">Time</div>
        <div class="seq-lanes">
          @for (host of hosts; track host) {
            <div class="seq-host">{{ host }}</div>
          }
        </div>
      </div>
      <div class="seq-body">
        @for (item of flowItems; track item; let idx = $index) {
          <div
            class="seq-row"
            [class.selected]="getSelected(idx)"
            (click)="setSelected(idx)"
            >
            <div class="seq-time">{{ formatTime(item.t) }}</div>
            <div class="seq-lanes">
              @for (host of hosts; track host) {
                <div class="seq-lane">
                  <div class="seq-vline"></div>
                </div>
              }
              <div
                class="seq-msg"
                [class.left]="arrowBox(item).reverse"
                [style.left.%]="arrowBox(item).left"
                [style.width.%]="arrowBox(item).width"
                [style.color]="arrowColor(item)"
                >
                <span>{{ item.c }}</span>
                <div class="seq-arrow" [class.left]="arrowBox(item).reverse"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</isData>
